<script>
export default {
  name: "SimpleRubricPreviewTable",
  props: {
    criteria: {
      type: Array,
      required: true,
    },
    isDefault: Boolean,
  },
};
</script>

<template>
  <eg-b-table-simple outlined striped hover responsive>
    <eg-b-thead class="caption-s">
      <eg-b-tr>
        <eg-b-th>{{ $t("rubrics.gradingCriteria") }}</eg-b-th>
        <eg-b-th v-if="!isDefault">{{ $t("rubrics.gradeLabel") }}</eg-b-th>
      </eg-b-tr>
    </eg-b-thead>
    <eg-b-tbody class="paragraph-s">
      <eg-b-tr v-for="criterion in criteria" :key="criterion.id">
        <eg-b-td>{{ criterion.point }}</eg-b-td>
        <eg-b-td v-if="!isDefault">{{ criterion.scale }}</eg-b-td>
      </eg-b-tr>
    </eg-b-tbody>
  </eg-b-table-simple>
</template>

<style scoped lang="scss"></style>
